// extracted by mini-css-extract-plugin
module.exports = {"root":"StaticPage_root__3w0rZ","rotate":"StaticPage_rotate__kuTO6"};